<script>
import { useFundraiserPagePublicStore } from '@/stores/fundraiserPagePublic.js'
import FundraiserPageLayoutModern from '@/pages/fundraisers/public/layouts/fundraiser-page/FundraiserPageLayoutModern.vue'
import FundraiserPageLayoutModernMobile from '@/pages/fundraisers/public/layouts/fundraiser-page/FundraiserPageLayoutModernMobile.vue'
import FundraiserPageLayoutWidget from '@/pages/fundraisers/public/layouts/fundraiser-page/FundraiserPageLayoutWidget.vue'
import fundraiserPagePublicFetchMixin from '@/mixins/fundraiserPagePublicFetchMixin.js'

export default {
  name: 'FundraiserPagePublicPage',
  components: { FundraiserPageLayoutModern, FundraiserPageLayoutModernMobile, FundraiserPageLayoutWidget },
  mixins:[fundraiserPagePublicFetchMixin],
  props: {
    fundraiserPageId: {
      type: Number,
      required: true
    },
    layout: {
      type: String,
      default: 'fundraiser-page-layout-modern-mobile'
    }
  }
}
</script>

<template>
  <component :is="layout" v-if="fundraiserPageId" :fundraiser-page-id="fundraiserPageId" />
</template>

<style scoped>

</style>
